import type { SlideWithSubslides } from "@/lib/hooks/slides/useSlidesByLessonId";
import type { SlideFields } from "@/types/Slide";

/**
 * A lesson as it plays: every main slide followed by its own subslides. Homework stores exactly
 * this flat list, so a teacher walking a lesson sees the order a student will.
 */
export function toPlayOrder(slides: SlideWithSubslides[]): SlideFields[] {
  return slides.flatMap((slide) => [slide, ...slide.children]);
}
